import * as Types from '../../../../../generated/types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type OwnOrganizationsFilterSiloOrgGroupQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type OwnOrganizationsFilterSiloOrgGroupQuery = { __typename: 'Query', organization: { __typename: 'Organization', organizationGroup?: { __typename: 'OrganizationGroup', id: string, organizations: Array<{ __typename: 'Organization', id: string, name?: string | null, isActive: boolean }> } | null } };

export const OwnOrganizationsFilterSiloOrgGroupDocument = gql`
    query ownOrganizationsFilterSiloOrgGroup($id: ID!) {
  organization(id: $id) {
    organizationGroup {
      id
      organizations {
        id
        name
        isActive
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OwnOrganizationsFilterSiloOrgGroupGQL extends Apollo.Query<OwnOrganizationsFilterSiloOrgGroupQuery, OwnOrganizationsFilterSiloOrgGroupQueryVariables> {
    override document = OwnOrganizationsFilterSiloOrgGroupDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }